import { render, staticRenderFns } from "./extactBtn.vue?vue&type=template&id=3143b79f&scoped=true"
import script from "./extactBtn.vue?vue&type=script&lang=ts"
export * from "./extactBtn.vue?vue&type=script&lang=ts"
import style0 from "./extactBtn.vue?vue&type=style&index=0&id=3143b79f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143b79f",
  null
  
)

export default component.exports